// extracted by mini-css-extract-plugin
module.exports = {"shareButton":"ShareButton_shareButton__86F5R","label":"ShareButton_label__4Nej5"};